/**
 * maskCredential
 *
 * Masks a credential string for safe logging.
 * Shows only the first `visibleChars` characters and appends "..." for longer strings.
 *
 * @param value - The credential string to mask
 * @param visibleChars - Number of characters to keep visible (default: 8)
 * @returns Masked credential string
 */
export function maskCredential(
  value: string,
  visibleChars: number = 8
): string {
  if (value.length <= visibleChars) return '*'.repeat(value.length);
  return value.slice(0, visibleChars) + '...';
}
